import { useState, useRef, useEffect, useCallback } from 'react'
import { Button, Spacing, Textbox, HalfSpacing } from '@/form/FormComponents'
import { SignInContainer } from '@/pages/SignedOutLayout'
import { useErrorModal, useModal, Modal, ModalContent } from '@/components/Modal';
import { signInAnonymously, signOut, refreshUserdata } from '@/systems/Authentication'
import { useParams, useNavigate, useLoaderData } from 'react-router'
import { Spinner } from '@/components/Spinner'

export function DemoLayout() {
  const navigate = useNavigate();
  const join_code = useParams().join_code;
  const assessment_id = useParams().assessment_id;
  const [openErrorModal] = useErrorModal();
  const [loading, setLoading] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const small_screen = screenWidth <= 1000;

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const startDemo = useCallback(() => {
    setLoading(true);
    signOut().then(function() {
      signInAnonymously({name: "Demo User", source_id: "demo"}).then(function() {

        navigate("/join/"+join_code+"/"+assessment_id, { replace: true });

      }).catch(function(error) {
        console.error(error);
        openErrorModal(error);
      });
    });
  }, [join_code, assessment_id, navigate]);

  useEffect(() => {
    if (!small_screen) {
      startDemo();
    }
  }, [startDemo, small_screen]);

  if (!small_screen) {
    return (
      <SignInContainer loading={false}>
        <div className="setup_title">Starting your free example case...</div>
        <Spinner style={{width: "50px", height: "50px", margin: "0 auto"}}/>
        <Spacing/>
        <Spacing/>
      </SignInContainer>
    )
  }

  return (
    <SignInContainer loading={loading}>
      <div className="setup_title">{"Larger screen recommended"}</div>
      <div className="setup_description">{"The example case works better on a larger screen. We recommend using your computer instead of a phone."}</div>
      <Spacing/>
      <Spacing/>
      <HalfSpacing/>
      <div className="buttons right">
        <Button text="Continue anyway" className="primary" onClick={startDemo}/>
      </div>
    </SignInContainer>
  )
}